import "./index.css";
import { Button } from "antd";
import React, { memo } from "react";
import GetLendersBanner from "./Banner";
import { IS_IFRAMES } from "MortgageGPT/constants";

interface TypeGetLendersProps {
  isMobile: boolean;
}

// 未登录用户
//  卡片不可关闭
//  仅在页面首次加载时展示animation
//  从对话页返回主页面时，不再触发动画
//  卡片始终固定在该位置展示
// 已登录用户
//  卡片可关闭
//  无animation
//  关闭后当前session不再展示，再次加载页面展示
//  卡片默认固定在该位置

/**
 * @name GetLenders Looking for other lender programs?
 * @description "未登陆用户" 才展示
 */
const GetLenders: React.FC<TypeGetLendersProps> = ({ isMobile }) =>
  IS_IFRAMES ? null : isMobile ? (
    <div className="get-lenders">
      <GetLendersBanner />
      <img src="/programs.png" height={123} />
    </div>
  ) : (
    <div className="get-lenders-desktop">
      <span>Need customization?</span>
      <div />
      <Button
        type="link"
        onClick={() => {
          window.open("https://www.zeitro.com/demo", "_blank");
        }}
      >
        Book a Demo
      </Button>
    </div>
  );

export default memo(GetLenders);
